import {
  ConsultaSeguimentoPergunta12ExemplosEnum,
  ConsultaSeguimentoPergunta12ExemplosPassouFalhouEnum,
  ConsultaSeguimentoPergunta12Model,
} from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-12/model-consultaSeguimentoPergunta12'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { booleanToSimNaoEnum, SimNaoEnum } from 'components/form'
import { MChatPerguntaEnum } from 'graphql/types.generated'

import { convertToPassouFalhou, HISTORICO_MCHAT_CALCULATION_STATUS } from '../utils-HistoricoMchatRf'

interface HistoricoMChatRfPergunta12Model {
  header: MchatRfAplicacaoQueryModel
  exemplos: MchatRfAplicacaoQueryModel[]
  exemplosPassou: ReadonlyArray<MchatRfAplicacaoQueryModel>
  exemplosFalhou: ReadonlyArray<MchatRfAplicacaoQueryModel>
  perguntaMaiorFrequencia: MchatRfAplicacaoQueryModel | undefined
  model: ConsultaSeguimentoPergunta12Model
}

export const convertAplicacaoPergunta12 = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): HistoricoMChatRfPergunta12Model | null => {
  const header = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_12_01)
  const exemplos = aplicacoes.filter((aplicacao) => PERGUNTA_12_EXEMPLOS.includes(aplicacao.pergunta))
  const exemplosPassou = aplicacoes.filter((aplicacao) => PERGUNTA_12_EXEMPLOS_PASSOU.includes(aplicacao.pergunta))
  const exemplosFalhou = aplicacoes.filter((aplicacao) => PERGUNTA_12_EXEMPLOS_FALHOU.includes(aplicacao.pergunta))
  const perguntaMaiorFrequencia = aplicacoes.find(
    (aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_12_18
  )
  const outro = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_12_12)
  if (header == undefined) return null

  return {
    header,
    exemplos,
    exemplosPassou,
    exemplosFalhou,
    perguntaMaiorFrequencia,
    model: {
      status: HISTORICO_MCHAT_CALCULATION_STATUS,
      PERGUNTA_12_HEADER: booleanToSimNaoEnum(header.stPassou),
      PERGUNTA_12_EXEMPLOS: convertAplicacoesToExemplos(exemplos),
      PERGUNTA_12_EXEMPLOS_PASSOU_FALHOU: {
        PASSOU: convertAplicacoesToExemplosPassouFalhou(exemplosPassou),
        FALHOU: convertAplicacoesToExemplosPassouFalhou(exemplosFalhou),
      },
      PERGUNTA_12_FREQUENCIA: convertToPassouFalhou(perguntaMaiorFrequencia?.stPassou),
      OUTRO: convertAplicacaoToOutro(outro),
    },
  }
}

const convertAplicacaoToOutro = (
  aplicacao: MchatRfAplicacaoQueryModel | undefined
): ConsultaSeguimentoPergunta12Model['OUTRO'] => ({
  radioValue: booleanToSimNaoEnum(aplicacao?.stPassou),
  textValue: aplicacao?.outros ?? undefined,
})

const convertAplicacoesToExemplos = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): Record<ConsultaSeguimentoPergunta12ExemplosEnum, SimNaoEnum | undefined> =>
  aplicacoes.reduce<Record<ConsultaSeguimentoPergunta12ExemplosEnum, SimNaoEnum | undefined>>(
    (acc, aplicacao) => {
      const pergunta = MAP_PERGUNTA_TO_ENUM[aplicacao.pergunta]

      if (pergunta) {
        acc[pergunta] = booleanToSimNaoEnum(aplicacao.stPassou)
      }

      return acc
    },
    { ...EMPTY_EXEMPLOS }
  )

const convertAplicacoesToExemplosPassouFalhou = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): Record<ConsultaSeguimentoPergunta12ExemplosPassouFalhouEnum, SimNaoEnum | undefined> =>
  aplicacoes.reduce<Record<ConsultaSeguimentoPergunta12ExemplosPassouFalhouEnum, SimNaoEnum | undefined>>(
    (acc, aplicacao) => {
      const pergunta = MAP_PERGUNTA_TO_ENUM_PASSOU_FALHOU[aplicacao.pergunta]

      if (pergunta) {
        acc[pergunta] = booleanToSimNaoEnum(aplicacao.stPassou)
      }

      return acc
    },
    { ...EMPTY_EXEMPLOS_PASSOU_FALHOU }
  )

const PERGUNTA_12_EXEMPLOS = [
  MChatPerguntaEnum.PERGUNTA_12_02,
  MChatPerguntaEnum.PERGUNTA_12_03,
  MChatPerguntaEnum.PERGUNTA_12_04,
  MChatPerguntaEnum.PERGUNTA_12_05,
  MChatPerguntaEnum.PERGUNTA_12_06,
  MChatPerguntaEnum.PERGUNTA_12_07,
  MChatPerguntaEnum.PERGUNTA_12_08,
  MChatPerguntaEnum.PERGUNTA_12_09,
  MChatPerguntaEnum.PERGUNTA_12_10,
  MChatPerguntaEnum.PERGUNTA_12_11,
  MChatPerguntaEnum.PERGUNTA_12_12,
]

const PERGUNTA_12_EXEMPLOS_PASSOU = [MChatPerguntaEnum.PERGUNTA_12_13, MChatPerguntaEnum.PERGUNTA_12_14]

const PERGUNTA_12_EXEMPLOS_FALHOU = [
  MChatPerguntaEnum.PERGUNTA_12_15,
  MChatPerguntaEnum.PERGUNTA_12_16,
  MChatPerguntaEnum.PERGUNTA_12_17,
]

const EMPTY_EXEMPLOS: Record<ConsultaSeguimentoPergunta12ExemplosEnum, undefined> = {
  [ConsultaSeguimentoPergunta12ExemplosEnum.MAQUINA_DE_LAVAR]: undefined,
  [ConsultaSeguimentoPergunta12ExemplosEnum.CHORO_DE_BEBES]: undefined,
  [ConsultaSeguimentoPergunta12ExemplosEnum.ASPIRADOR_DE_PO]: undefined,
  [ConsultaSeguimentoPergunta12ExemplosEnum.SECADOR_DE_CABELO]: undefined,
  [ConsultaSeguimentoPergunta12ExemplosEnum.TRANSITO]: undefined,
  [ConsultaSeguimentoPergunta12ExemplosEnum.GRITO_DE_BEBES]: undefined,
  [ConsultaSeguimentoPergunta12ExemplosEnum.MUSICA_ALTA]: undefined,
  [ConsultaSeguimentoPergunta12ExemplosEnum.TOQUE_TELEFONE_CAMPAINHA]: undefined,
  [ConsultaSeguimentoPergunta12ExemplosEnum.BARULHO_DE_LIQUIDIFICADOR]: undefined,
  [ConsultaSeguimentoPergunta12ExemplosEnum.LUGARES_BARULHENTOS]: undefined,
}

const EMPTY_EXEMPLOS_PASSOU_FALHOU: Record<ConsultaSeguimentoPergunta12ExemplosPassouFalhouEnum, undefined> = {
  [ConsultaSeguimentoPergunta12ExemplosPassouFalhouEnum.TAMPA_OUVIDOS_CALMAMENTE]: undefined,
  [ConsultaSeguimentoPergunta12ExemplosPassouFalhouEnum.NAO_GOSTA_BARULHO]: undefined,
  [ConsultaSeguimentoPergunta12ExemplosPassouFalhouEnum.GRITA]: undefined,
  [ConsultaSeguimentoPergunta12ExemplosPassouFalhouEnum.CHORA]: undefined,
  [ConsultaSeguimentoPergunta12ExemplosPassouFalhouEnum.TAMPA_OUVIDOS]: undefined,
}

const MAP_PERGUNTA_TO_ENUM: Partial<Record<MChatPerguntaEnum, ConsultaSeguimentoPergunta12ExemplosEnum>> = {
  [MChatPerguntaEnum.PERGUNTA_12_02]: ConsultaSeguimentoPergunta12ExemplosEnum.MAQUINA_DE_LAVAR,
  [MChatPerguntaEnum.PERGUNTA_12_03]: ConsultaSeguimentoPergunta12ExemplosEnum.CHORO_DE_BEBES,
  [MChatPerguntaEnum.PERGUNTA_12_04]: ConsultaSeguimentoPergunta12ExemplosEnum.ASPIRADOR_DE_PO,
  [MChatPerguntaEnum.PERGUNTA_12_05]: ConsultaSeguimentoPergunta12ExemplosEnum.SECADOR_DE_CABELO,
  [MChatPerguntaEnum.PERGUNTA_12_06]: ConsultaSeguimentoPergunta12ExemplosEnum.TRANSITO,
  [MChatPerguntaEnum.PERGUNTA_12_07]: ConsultaSeguimentoPergunta12ExemplosEnum.GRITO_DE_BEBES,
  [MChatPerguntaEnum.PERGUNTA_12_08]: ConsultaSeguimentoPergunta12ExemplosEnum.MUSICA_ALTA,
  [MChatPerguntaEnum.PERGUNTA_12_09]: ConsultaSeguimentoPergunta12ExemplosEnum.TOQUE_TELEFONE_CAMPAINHA,
  [MChatPerguntaEnum.PERGUNTA_12_10]: ConsultaSeguimentoPergunta12ExemplosEnum.BARULHO_DE_LIQUIDIFICADOR,
  [MChatPerguntaEnum.PERGUNTA_12_11]: ConsultaSeguimentoPergunta12ExemplosEnum.LUGARES_BARULHENTOS,
}

const MAP_PERGUNTA_TO_ENUM_PASSOU_FALHOU: Partial<Record<
  MChatPerguntaEnum,
  ConsultaSeguimentoPergunta12ExemplosPassouFalhouEnum
>> = {
  [MChatPerguntaEnum.PERGUNTA_12_13]: ConsultaSeguimentoPergunta12ExemplosPassouFalhouEnum.TAMPA_OUVIDOS_CALMAMENTE,
  [MChatPerguntaEnum.PERGUNTA_12_14]: ConsultaSeguimentoPergunta12ExemplosPassouFalhouEnum.NAO_GOSTA_BARULHO,
  [MChatPerguntaEnum.PERGUNTA_12_15]: ConsultaSeguimentoPergunta12ExemplosPassouFalhouEnum.GRITA,
  [MChatPerguntaEnum.PERGUNTA_12_16]: ConsultaSeguimentoPergunta12ExemplosPassouFalhouEnum.CHORA,
  [MChatPerguntaEnum.PERGUNTA_12_17]: ConsultaSeguimentoPergunta12ExemplosPassouFalhouEnum.TAMPA_OUVIDOS,
}
